import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsEvents } from '@irb-common/events';
import { ImportModelCategoryResultGridLayoutService } from '@irb/irb-clients/import-model-category-result-dialog/import-model-category-result.grid-layout.service';


@Component({ standalone: false,
  selector: 'irb-import-model-category-result-dialog',
  templateUrl: './import-model-category-result-dialog.component.html',
  styleUrls: ['./import-model-category-result-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportModelCategoryResultDialogComponent implements OnInit {
  grid: any;
  gridOptions: any;
  frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<ImportModelCategoryResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls: ImportModelCategoryResultGridLayoutService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    this.as.fireEvent(IrbClientsEvents.IMPORT_MODEL_CATEGORY_COMPLETE, this.data);
    this.close();
  }
}
